var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tag == 'div')?_c('div',{staticClass:"swiper-slide"},[_vm._t("default")],2):(_vm.tag == 'ul')?_c('ul',{staticClass:"swiper-slide"},[_vm._t("default")],2):(_vm.tag == 'li')?_c('li',{staticClass:"swiper-slide"},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }